import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import LoadingScreen from '../../components/Common/LoadingScreen';

interface ProtectedRouteProps {
  restrictedEmails?: string[];
  allowLenderIqForAll?: boolean;
}

const ProtectedRoute = ({ 
  restrictedEmails = [],
  allowLenderIqForAll =true
}: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, user } = useAuth0();
  const location = useLocation();
  const userEmail = user?.email?.toLowerCase() || ''; 

  if (isLoading) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to="/" replace />;
console.log("user",user);

  // Normalize emails for comparison
  const normalizedLenderEmails = restrictedEmails.map(email => email.toLowerCase());
  const isLender = normalizedLenderEmails.includes(userEmail);

  // Lender access control
  if (isLender && location.pathname !== '/lender-iq') {
    return <Navigate to="/lender-iq" replace />;
  }

  // Only restrict /lender-iq if explicitly configured
  if (!allowLenderIqForAll && !isLender && location.pathname === '/lender-iq') {
    return <Navigate to="/contacts" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;